__turbopack_context__.v({
  "className": "daxprobold_59681c29-module__jT7T_W__className",
  "variable": "daxprobold_59681c29-module__jT7T_W__variable",
});
